import useAuth from "@/hooks/use-auth";

import Booking from "./booking";
import useUpcomingBookings from "./graphql";

export default function Bookings() {
  const { isUser, queryContext } = useAuth();
  const { data } = useUpcomingBookings({ ...queryContext(), skip: !isUser });

  if (!(data?.bookings || []).length) {
    return null;
  }

  return (
    <section className="flex flex-col items-stretch gap-2.5 md:gap-5">
      <h3 className="font-medium text-18/[1.5em] text-white">
        Upcoming bookings
      </h3>
      <div className="scrollbar-hidden -mx-[25px] flex snap-x snap-mandatory gap-2.5 overflow-auto px-[25px] md:mx-0 md:snap-none md:flex-col md:gap-5 md:overflow-visible md:px-0">
        {data?.bookings.map((booking) => (
          <Booking booking={booking} key={booking.id} />
        ))}
      </div>
    </section>
  );
}
